
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UserContext from '../context/UserContext';
import { setAuthToken } from '../services/apiService';
import Cookies from 'js-cookie';
import { ENV } from '../constants';
class Login extends Component {
  state = {success: true};
  componentDidMount() {
    try {
      console.log('running in Env', ENV);
      let user;
      let token;
      if(ENV?.toLowerCase() === 'local') {
        user = {displayName: 'TestUser', userPrincipalName: "k0p05h9@walmart.com"};
        token = "dummy-token";
      } else {
        console.log('document.cookie', document.cookie);
        const encodedUserStr = Cookies.get('ddir-user');
        console.log('encoded user', encodedUserStr);
        const userStr = atob(encodedUserStr);
        user = JSON.parse(userStr);
        console.log('user', user);
        token = Cookies.get('ddir-access-token');
        console.log('access token', token);
      }
      setAuthToken(token, ()=> {
        alert("Session timeout");
        this.props.history.push('/');
      });
      this.context.handleLogin(user, ()=>{
        let redirect = sessionStorage.getItem('ddir_post_login_redirect') || '/dashboard';
        sessionStorage.removeItem('ddir_post_login_redirect');
        // Only allow same-app relative paths — reject protocol-relative ("//host")
        // or absolute URLs ("https://...") to prevent an open redirect if this
        // sessionStorage value were ever attacker-controlled (e.g. via XSS).
        if (!redirect.startsWith('/') || redirect.startsWith('//') || redirect.includes('://')) {
          redirect = '/dashboard';
        }
        this.props.history.push(redirect);
      });
    } catch(err) {
      console.error(err);
      this.setState({success: false});
    }
  }
  render() {
    if(this.state.success) {
      return (<div> 
        Logging in ...
      </div>);
    } else {
      return (<div> 
        Login failed! Do you want to try again?
        {' '}<button onClick={()=>this.props.history.push('/')}>login again</button>
      </div>);
    }
    
  }
}
Login.contextType = UserContext;

Login.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  })
};

export default Login;